export default {
    "Welcome to financial": "Bem vindo ao financeiro",
};
